<template>
  <div class="container mt-4">
    <div class="row">
      <!-- Item -->
      <div class="col" style="height: 500px; position: relative;">
        <div v-for="item in extra.points" :key="item.id" class="item" :id="item.id" :style="'left: ' + item.posX + 'px;top: ' + item.posY + 'px'">
          <h1 :class="item.icon"></h1>
          <small v-if="item.dataDevice && item.dataValue">{{ $store.getters.device(item.dataDevice)[item.dataValue] }} <span v-if="item.dataUnit">{{ item.dataUnit }}</span></small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeaderLine from 'leader-line-vue'
export default {
  props: ['title', 'extra'],
  data () {
    return {
      points2: [
        {
          id: 'item-1',
          target: 'item-2',
          icon: 'fas fa-solar-panel',
          options: { dash: { animation: true } },
          dataDevice: 'ACREL_ADL400_MATTIAS',
          dataValue: 'Total_active_power',
          dataUnit: 'kW',
          posX: 0,
          posY: 0
        },
        {
          id: 'item-2',
          icon: 'fas fa-home',
          posX: 100,
          posY: 350
        },
        {
          id: 'item-3',
          target: 'item-2',
          icon: 'fas fa-horse',
          posX: 300,
          posY: 250
        }
      ]
    }
  },
  created () {},
  mounted () {
    this.extra.points.filter(obj => obj.target !== undefined).forEach((point) => {
      LeaderLine.setLine(
        document.getElementById(point.id),
        document.getElementById(point.target),
        point.options
      )
    })
  }
}
</script>

<style>
.item {
  text-align: center;
  height: auto;
  z-index: 9;
  width: 60px;
  border: 1px red dashed;
  position: absolute;
}
</style>
